import { useState } from 'react';
import { apiClient } from '@services/api';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@material-ui/core/TableFooter';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import NumberFormat from 'react-number-format';
import Moment from 'react-moment';
import ChangeDate from './ChangeDate';
import ChangeDateTransfer from './ChangeDateTransfer';
import ChangeFlight from './ChangeFlight';
import { Link } from 'react-router-dom';
import Button from '@components/Button';
import Icon from '@material-ui/core/Icon';
import DeleteModal from '@components/DeleteModal'

const useStyles = makeStyles({
  tableContainer: {
    boxShadow: 'none',
  },
  table: {
    minWidth: 650,
  },
  borderNone: {
    border: 'none'
  }
});

const RequestTable = (props) => {
  const [changeDate, setChangeDate] = useState(false)
  const [changeDateTransfer, setChangeDateTransfer] = useState(false)
  const [date, setDate] = useState(null)
  const [modalFlight, setModalFlight] = useState(false)
  const [flight, setFlight] = useState(null)
  const [flightTime, setFlightTime] = useState(null)
  const [tourId, setTourId] = useState(null)
  const [index, setIndex] = useState(null)
  const classes = useStyles();
  const [disableModal, setDisableModal] = useState(false);
  const [idReservation, setIdReservation] = useState('');
  const [idxRow, setIdxRow] = useState('');
  const [discount, setDiscount] = useState(0);
  const [justify, setJustify] = useState('');
  const [toApprove, setToApprove] = useState(false);

  const history = useHistory();

  const handleModal = (row, idx) => {
    setIdReservation(row.id)
    setIdxRow(idx)
    setDisableModal(true)
  }

  const cancelReservation = () => {
    /* apiClient.httpInstance.post(`/reservations/${idReservation}/cancel`).then(response => {
      if (response.status === 200) {
        props.dataBudgets[idxRow].status = 0
        setDisableModal(false)
      }
    }); */
  }

  const discountTotal = () => {
    const total = props.dataBudgets.reduce((accumulator, currentValue) => accumulator + Number(currentValue.total_amount), 0)
    return total * discount / 100
  }

  const calcSubtotal = () => {
    const total = props.dataBudgets.reduce((accumulator, currentValue) => accumulator + Number(currentValue.total_amount), 0)
    return Number(total)
  }

  // Subtotal só de passeios (exclui transfers) — base do desconto gerencial %
  const calcSubtotalTours = () => {
    return props.dataBudgets.reduce((acc, b) => {
      if (b.type === 'transfer') return acc;
      return acc + Number(b.total_amount || 0);
    }, 0);
  }

  const calcTotal = () => {
    const total = props.dataBudgets.reduce((accumulator, currentValue) => accumulator + Number(currentValue.total_amount), 0)
    return !toApprove ? Number(total) : total.toFixed(2) - (total.toFixed(2) * Number(discount / 100))
  }

  return <>
    <TableContainer className={classes.tableContainer} component={Paper}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className="font-bold leading-5 text-blue border-0">
              Minhas reservas
            </TableCell>
            <TableCell className="font-bold leading-5 text-blue border-0">
              Passageiros
            </TableCell>
            <TableCell className="font-bold leading-5 text-blue border-0">
              Valor
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[...props.dataBudgets].sort((a, b) => new Date(a.tour_date) - new Date(b.tour_date)).map((row, idx) => (
            <TableRow key={row.id}>
              <TableCell className="leading-5 text-blue border-0" component="th" scope="row">
                <div className="flex items-center">
                  <div className="flex-auto space-y-3">
                    <div className="font-medium text-lg">
                      {row.tour_name}
                    </div>
                    <div>
                      {row.status === 0 ? <Icon className="mr-1 text-red-500" fontSize="small">block</Icon> : ''}{row.travel_name} {row.transfer_type ? `(${row.transfer_type})` : null}
                    </div>
                  </div>
                </div>
              </TableCell>
              <TableCell className="leading-5 text-blue border-0" component="th" scope="row">
                {row.type === 'transfer' ? (
                  row.adults_total
                ) : row.modality === 'single' ? (
                  /* Tour privado: preço por intervalo, sem breakdown por pessoa */
                  <div style={{ lineHeight: 1.6, fontSize: 13 }}>
                    {(parseInt(row.adults_total || 0) + parseInt(row.kids_total || 0))} pessoa{(parseInt(row.adults_total || 0) + parseInt(row.kids_total || 0)) !== 1 ? 's' : ''}
                  </div>
                ) : (
                  <div style={{ lineHeight: 1.6, fontSize: 13 }}>
                    {parseInt(row.adults_total || 0) > 0 && (
                      <div>
                        {row.adults_total} adulto{row.adults_total > 1 ? 's' : ''}
                        {row.adults_total_amount > 0 &&
                          <span style={{ opacity: 0.65, marginLeft: 6 }}>
                            × {process.env.REACT_APP_CURRENCY} {(Number(row.adults_total_amount) / Number(row.adults_total)).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                          </span>
                        }
                      </div>
                    )}
                    {parseInt(row.kids_total || 0) > 0 && (
                      <div>
                        {row.kids_total} criança{row.kids_total > 1 ? 's' : ''}
                        {row.kids_total_amount > 0 &&
                          <span style={{ opacity: 0.65, marginLeft: 6 }}>
                            × {process.env.REACT_APP_CURRENCY} {(Number(row.kids_total_amount) / Number(row.kids_total)).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                          </span>
                        }
                      </div>
                    )}
                  </div>
                )}
              </TableCell>
              <TableCell className="leading-5 text-blue border-0" component="th" scope="row">
                <div style={{ lineHeight: 1.6, fontSize: 13 }}>
                  {row.type !== 'transfer' && row.modality !== 'single' && parseInt(row.adults_total || 0) > 0 && Number(row.adults_total_amount) > 0 && (
                    <div>
                      <NumberFormat value={Number(row.adults_total_amount)} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => <span>{v}</span>} />
                    </div>
                  )}
                  {row.type !== 'transfer' && row.modality !== 'single' && parseInt(row.kids_total || 0) > 0 && Number(row.kids_total_amount) > 0 && (
                    <div>
                      <NumberFormat value={Number(row.kids_total_amount)} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => <span style={{ opacity: 0.75 }}>{v}</span>} />
                    </div>
                  )}
                  <div style={{ fontWeight: 600 }}>
                    <NumberFormat value={Number(row.total_amount) || Number(row.price) || 0} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => <span>{v}</span>} />
                  </div>
                </div>
              </TableCell>
              {props.isEditing && <TableCell className="leading-5 text-blue border-0" component="th" scope="row">
                {row.status !== 0 ? <><Button
                  textcolor="red"
                  padding="4px"
                  width="50"
                  variant="outlined"
                  bgColor="transparent"
                  onClick={() => handleModal(row, idx)}
                >
                  X
                </Button>
                </>
                  : ''}
              </TableCell>
              }
              {row.type === 'tour' && <ChangeDate
                type={row.type}
                open={changeDate}
                close={() => setChangeDate(false)}
                setDate={props.changeDate}
                date={date}
                idx={index}
                tourId={tourId}
                {...props}
              />}
              {row.type === 'transfer' && <ChangeDateTransfer
                type={row.type}
                open={changeDateTransfer}
                close={() => setChangeDateTransfer(false)}
                setDate={props.changeDate}
                date={date}
                idx={index}
                tourId={tourId}
                {...props}
              />}
              <ChangeFlight
                type={row.type}
                open={modalFlight}
                close={() => setModalFlight(false)}
                setFlight={props.changeFlight}
                setFlightTime={props.changeFlightTime}
                flight={flight}
                flightTime={flightTime}
                idx={index}
                tourId={tourId}
                {...props}
              />
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell className="text-lg font-medium leading-5 border-0 text-blue">
              Subtotal
            </TableCell>
            <TableCell align="right" colSpan={3} className="text-lg font-medium leading-5 border-0 text-blue">
              <NumberFormat
                value={calcSubtotal().toFixed(2)}
                displayType={'text'}
                decimalSeparator={","}
                decimalScale={2}
                fixedDecimalScale={true}
                decimalPrecision={2}
                thousandSeparator={"."}
                isNumericString
                prefix={`${process.env.REACT_APP_CURRENCY} `}
                renderText={(value) => <span>{value}</span>}
              />
            </TableCell>
          </TableRow>
          {/* Descontos solicitados + Justificativa — oculta quando há desconto gerencial */}
          {!props.presaleApproval && (
            <>
              <TableRow>
                <TableCell className="text-lg font-medium leading-5 border-0 text-blue">
                  Descontos solicitados
                </TableCell>
                <TableCell align="right" colSpan={3} className="text-lg font-medium leading-5 border-0 text-blue">
                  <NumberFormat
                    value={((parseInt(props?.dataBudgets[0]?.discount_total_sale || 0) * calcTotal() / 100).toFixed(2))}
                    displayType={'text'}
                    decimalSeparator={","}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    decimalPrecision={2}
                    thousandSeparator={"."}
                    isNumericString
                    prefix={`${process.env.REACT_APP_CURRENCY} `}
                    renderText={(value) => <span>{value}</span>}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="text-lg font-medium leading-5 border-0 text-blue">
                  Justificativa
                </TableCell>
                <TableCell align="right" colSpan={3} className="text-lg font-medium leading-5 border-0 text-blue">
                  {props?.dataBudgets[0]?.justify_discount}
                </TableCell>
              </TableRow>
            </>
          )}
          {props.presaleApproval && (
            <>
              <TableRow>
                <TableCell className="text-lg font-medium leading-5 border-0 text-blue" style={{ color: '#a78bfa' }}>
                  Desconto gerencial aprovado
                </TableCell>
                <TableCell align="right" colSpan={3} className="text-lg font-medium leading-5 border-0" style={{ color: '#a78bfa' }}>
                  {props.presaleApproval.type === 'discount_pct'
                    ? `${props.presaleApproval.managerValue}% (R$ ${(calcSubtotalTours() * parseFloat(props.presaleApproval.managerValue) / 100).toFixed(2).replace('.', ',')}) — sobre os passeios`
                    : `R$ ${parseFloat(props.presaleApproval.managerValue || 0).toFixed(2).replace('.', ',')}`}
                </TableCell>
              </TableRow>
              {props.presaleApproval.justify && (
                <TableRow>
                  <TableCell className="text-lg font-medium leading-5 border-0 text-blue" style={{ color: '#a78bfa' }}>
                    Justificativa gerencial
                  </TableCell>
                  <TableCell align="right" colSpan={3} className="text-lg font-medium leading-5 border-0" style={{ color: '#a78bfa' }}>
                    {props.presaleApproval.justify}
                    {props.presaleApproval.managerNote && <span style={{ opacity: 0.7, marginLeft: 8 }}>({props.presaleApproval.managerNote})</span>}
                  </TableCell>
                </TableRow>
              )}
            </>
          )}
          <TableRow>
            <TableCell className="text-lg font-medium leading-5 border-0 text-blue">
              Total
            </TableCell>
            <TableCell align="right" colSpan={3} className="text-lg font-medium leading-5 border-0 text-blue">
              <NumberFormat
                value={(() => {
                  const base = calcTotal() - (parseInt(props?.dataBudgets[0]?.discount_total_sale || 0) * calcTotal() / 100);
                  if (!props.presaleApproval) return base.toFixed(2);
                  const baseTours = calcSubtotalTours() * (1 - parseInt(props?.dataBudgets[0]?.discount_total_sale || 0) / 100);
                  const mgr = props.presaleApproval.type === 'discount_pct'
                    ? baseTours * parseFloat(props.presaleApproval.managerValue || 0) / 100
                    : parseFloat(props.presaleApproval.managerValue || 0);
                  return Math.max(0, base - mgr).toFixed(2);
                })()}
                displayType={'text'}
                decimalSeparator={","}
                decimalScale={2}
                fixedDecimalScale={true}
                decimalPrecision={2}
                thousandSeparator={"."}
                isNumericString
                prefix={`${process.env.REACT_APP_CURRENCY} `}
                renderText={(value) => <span>{value}</span>}
              />
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
      <DeleteModal
        open={disableModal}
        close={() => setDisableModal(false)}
        delete={() => cancelReservation()}
        title="Cancelar orçamento?"
        description="Você quer mesmo cancelar esse orçamento? Essa ação é irreversível."
      />
    </TableContainer>
  </>
}

export default RequestTable;
